import { registerPlugin } from '@capacitor/core';
const CapgoInAppReview = registerPlugin('CapgoInAppReview', {
    web: () => import('./web').then((m) => new m.CapgoInAppReviewWeb()),
});
export * from './definitions';
export { CapgoInAppReview };
//# sourceMappingURL=index.js.map